export const errorDataSummaryModalTranslationEN = {
  ErrorDataSummaryModal: {},
};
